import { graphql } from '@/gql'

export const CustomFieldsListQuery = graphql(/* GraphQl */ `
  query CustomFieldsList($accounts: [ID!], $appliesTo: [TypeSupportingCustomFieldValues!]) {
    customFields(accounts: $accounts, appliesTo: $appliesTo, first: 10000) {
      data {
        ...CustomFieldList
      }
    }
  }
`)

export const InheritedCustomFieldsListQuery = graphql(/* GraphQl */ `
  query InheritedCustomFieldsList($accounts: [ID!], $appliesTo: [TypeSupportingCustomFieldValues!]) {
    customFields: inheritedCustomFields(accounts: $accounts, appliesTo: $appliesTo, first: 10000) {
      data {
        ...CustomFieldList
      }
    }
  }
`)

export const CustomFieldDetailQuery = graphql(/* GraphQl */ `
  query customField($id: ID!) {
    customField(id: $id) {
      ...CustomFieldDetail
    }
  }
`)
